import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** What a screen reader hears for each state, after the step's label. */
export const STAGE_STEP_STATE_WORDS = {
    done: "done",
    current: "current step",
    todo: "not started",
};
const SR_ONLY = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
};
/** The segment fill and the text colour for one step, from tokens only. */
function toneFor(state, currentTone) {
    if (state === "done") {
        return { bar: "var(--status-approved)", label: "var(--ard-text)", detail: "var(--ard-text-2)" };
    }
    if (state === "current") {
        const hue = currentTone === "attention" ? "var(--agent-blocked)" : "var(--status-in-progress)";
        return { bar: hue, label: hue, detail: hue };
    }
    return { bar: "var(--ard-surface-3)", label: "var(--ard-text-2)", detail: "var(--ard-text-2)" };
}
export function StageStepper({ steps, currentTone = "active", label = "Progress", className, }) {
    if (steps.length === 0)
        return null;
    const cls = ["stage-stepper", className ?? ""].filter(Boolean).join(" ");
    return (_jsx("ol", { className: cls, "aria-label": label, style: {
            listStyle: "none",
            margin: 0,
            padding: "var(--space-5) var(--space-6)",
            display: "grid",
            gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))`,
            gap: "var(--space-2)",
            background: "var(--ard-surface)",
            border: "1px solid var(--ard-border)",
            borderRadius: "var(--radius-lg)",
        }, children: steps.map((step) => {
            const tone = toneFor(step.state, currentTone);
            return (_jsxs("li", { className: `stage-stepper__step stage-stepper__step--${step.state}`, "data-state": step.state, "aria-current": step.state === "current" ? "step" : undefined, style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--space-2)",
                    minWidth: 0,
                }, children: [_jsx("span", { "aria-hidden": "true", className: "stage-stepper__bar", style: {
                            height: "6px",
                            borderRadius: "var(--radius-full)",
                            background: tone.bar,
                        } }), _jsxs("span", { className: "stage-stepper__label", style: { font: "600 13px/1.3 var(--font-ui)", color: tone.label }, children: [step.label, _jsx("span", { style: SR_ONLY, children: `, ${STAGE_STEP_STATE_WORDS[step.state]}` })] }), step.detail !== undefined && step.detail !== "" && (_jsx("span", { className: "stage-stepper__detail", style: { font: "500 12px/1.35 var(--font-ui)", color: tone.detail }, children: step.detail }))] }, step.key));
        }) }));
}
export default StageStepper;
//# sourceMappingURL=StageStepper.js.map